<template>
  <v-layout align-start row pa-3>
    <v-fab-transition>
      <v-btn color="pink" dark fixed bottom right fab @click="createItem">
        <v-icon>add</v-icon>
      </v-btn>
    </v-fab-transition>
    <v-flex xs12>
      <v-alert :value="noData" dismissible color="error" icon="warning" outlined
        >We can't find an offer. Please use offer id or offer code.</v-alert
      >
      <v-card>
        <v-toolbar>
          <v-icon>local_offer</v-icon>
          <v-toolbar-title
            >Offers ({{ items.length || 0 }} total)</v-toolbar-title
          >
          <v-spacer></v-spacer>
          <v-text-field
            v-model="searchQuery"
            v-on:keyup.enter="search(searchQuery)"
          ></v-text-field>
          <v-btn icon @click.stop="search(searchQuery)">
            <v-icon>search</v-icon>
          </v-btn>
        </v-toolbar>
        <v-data-table
          :headers="headers"
          :items="items"
          :must-sort="true"
          class="mt-1"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:item="props">
            <tr>
              <td>
                <a @click.stop="updateItem(props.item)">{{
                  props.item.name.en
                }}</a>
              </td>
              <td>{{ showDiscount(props.item) }}</td>
              <td>{{ props.item.number }}</td>
              <td>
                <span
                  v-if="props.item.is_business"
                  class="green--text font-weight-medium"
                  >Yes</span
                >
              </td>
              <td>{{ props.item.created | moment("YYYY-MM-DD") }}</td>
              <td>
                <span v-if="props.item.valid_until">{{
                  props.item.valid_until | moment("YYYY-MM-DD")
                }}</span>
              </td>
              <td>
                <span
                  v-if="props.item.is_active"
                  class="green--text font-weight-medium"
                  >Active</span
                >
                <span v-else class="red--text font-weight-medium"
                  >Inactive</span
                >
              </td>
              <td class="justify-center layout px-0">
                <v-icon class="mr-2" @click.stop="updateItem(props.item)"
                  >edit</v-icon
                >
                <v-icon @click.stop="removeItem(props.item.id)">delete</v-icon>
              </td>
            </tr>
          </template>
          <template v-slot:no-data>No data</template>
        </v-data-table>
        <v-footer class="pt-5"></v-footer>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import fb from "@/firebase";
import { mapMutations } from "vuex";
import OfferForm from "@/components/OfferForm.vue";

const offers = fb.db.collection("partner_offers");

export default {
  components: {},
  data: () => ({
    items: [],
    newItemName: "",
    currentItem: {},
    searchQuery: "",
    noData: false,
    headers: [
      { text: "Name", value: "name.en" },
      { text: "Discount", value: "type", sortable: false },
      { text: "Number", value: "number", sortable: true },
      { text: "Is business?", value: "boolean", sortable: false },
      { text: "Created", value: "created" },
      { text: "Valid until", value: "valid_until", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "Actions", sortable: false, align: "center" }
    ],
    total: 0,
    modal: {
      name: "OfferForm",
      payload: {}
    }
  }),
  firestore: {
    items: offers
  },
  methods: {
    ...mapMutations(["setAppAlert"]),
    createItem() {
      const voidOffer = {
        name: {
          en: "",
          fr: ""
        },
        content: {
          en: "",
          fr: ""
        },
        available_for: [],
        available_on: []
      };
      this.$modal.show(
        OfferForm,
        {
          offer: voidOffer
        },
        {
          height: "auto",
          scrollable: true
        }
      );
    },
    removeItem(id) {
      if (id) {
        if (confirm("Are you sure ?")) {
          offers.doc(id).delete();
          this.setAppAlert({
            visible: true,
            text: "The offer has been removed",
            color: "success"
          });
        }
      }
    },
    updateItem(item) {
      this.currentItem = Object.assign({}, item);
      this.currentItem.id = item.id;
      this.$modal.show(
        OfferForm,
        {
          offer: this.currentItem
        },
        {
          height: "auto",
          scrollable: true
        }
      );
    },
    search: function(query) {
      this.noData = false;
      if (query && query.length >= 5) {
        fb.db
          .collection("partner_offers")
          .where("code", "==", query)
          .get()
          .then(snapshot => {
            if (!snapshot.empty) {
              snapshot.forEach(doc => {
                this.itemFound = doc.data();
                this.itemFound.id = doc.id;
              });
              this.items = [this.itemFound];
            } else {
              fb.db
                .collection("partner_offers")
                .doc(query)
                .get()
                .then(doc => {
                  if (doc.data()) {
                    this.itemFound = doc.data();
                    this.itemFound.id = doc.id;
                    this.items = [this.itemFound];
                  } else {
                    this.noData = true;
                  }
                })
                .catch(() => {
                  this.noData = true;
                });
            }
          });
      } else {
        this.$bind("items", fb.db.collection("partner_offers").orderBy("name"));
      }
    },
    showDiscount(item) {
      let discount = "N/A";
      if (item.type === "discount_code") {
        discount = item.code;
      } else if (item.type === "discount_amount") {
        discount = "-" + item.value + "€";
      } else if (item.type === "discount_percent") {
        discount = "-" + item.value + "%";
      }
      return discount;
    }
  }
};
</script>
